import React from "react";
import "../styles/DespreNoi.css";
import flowersImage from "../img/new/020loveletter.webp";
import flowersImageSmall from "../img/new/015hidrangeamelody.webp";
import flowersImage2 from "../img/buchete-premium/4silva-pink-and-tulips.webp";
import flowersImageSmall2 from "../img/buchete-premium//33mint-meadow.webp";
import flowersImage3 from "../img/buchete-de-primavara/1spring-radiance.webp";
import flowersImageSmall3 from "../img/buchete-de-primavara/5softly-spoken.webp";

const AboutUs = () => {
  return (
    // <div className="about-content">
    <div className=" section about-us">
      <h1 className="heading-secondary heading-about">
        Bine ai venit la Gardenia Flowers
      </h1>
      <div className="about-sections-box">
        <section className="about-section ">
          <div className="about-images about-images-1">
            <img
              src={flowersImageSmall}
              alt="Beautiful Flowers Large"
              className="about-image-large"
            />
            <img
              src={flowersImage}
              alt="Beautiful Flowers Small"
              className="about-image-small"
            />
          </div>
          <div className="about-content-text about-content-text-1">
            <h2 className="about-heading">Despre noi</h2>
            <p>
              Fondată în 2022, Gardenia Flowers s-a născut dintr-o pasiune
              autentică pentru frumusețea naturii și dorința de a oferi momente
              de neuitat prin arta aranjamentelor florale. Punem accent pe
              calitate în fiecare detaliu, de la prospețimea florilor atent
              selecționate până la serviciile de deservire ireproșabile. Pentru
              noi, fiecare buchet este mai mult decât o simplă combinație de
              flori - este o expresie a emoțiilor și o oglindă a perfecțiunii
              naturale.
            </p>
          </div>
        </section>

        <section className="about-section reverse">
          <div
            className="about-content-text 
about-content-text-2"
          >
            <h2 className="about-heading">
              Florăria noastră este locul unde florile spun povești și emoțiile
              prind viață!
            </h2>
            <p>
              Echipa noastră dedicată lucrează cu grijă pentru a crea
              aranjamente unice, personalizate după dorințele clienților noștri.
              Înțelegem că fiecare ocazie este specială, motiv pentru care
              suntem alături de tine, oferindu-ți consultanță și servicii de
              livrare care respectă cele mai înalte standarde. Alegând florăria
              noastră ,alegi să transformi fiecare moment într-o experiență
              memorabilă, înconjurată de frumusețea și delicatețea florilor.
            </p>
          </div>
          <div className="about-images about-images-2">
            <img
              src={flowersImageSmall2}
              alt="Beautiful Flowers Large"
              className="about-image-large"
            />
            <img
              src={flowersImage2}
              alt="Beautiful Flowers Small"
              className="about-image-small"
            />
          </div>
        </section>

        <section className="about-section about-section-last">
          <div className="about-images about-images-3">
            <img
              src={flowersImageSmall3}
              alt="Beautiful Flowers Large"
              className="about-image-large"
            />
            <img
              src={flowersImage3}
              alt="Beautiful Flowers Small"
              className="about-image-small"
            />
          </div>
          <div className="about-content-text about-content-text-3">
            <h2 className="about-heading">
              Suntem aici să aducem bucurie în viața ta, petală cu petală!
            </h2>
            <p>
              La Gardenia Flowers, credem că fiecare interacțiune cu clienții
              noștri trebuie să fie la fel de memorabilă ca florile pe care le
              oferim. De-a lungul anilor , ne-am dedicat nu doar să livrăm
              buchete impecabile, ci și să oferim o experiență desăvârșită, care
              să vă încânte la fiecare pas.
            </p>
          </div>
        </section>
        {/* </div> */}
      </div>
      <footer className="about-footer">
        <div className="heading-content">
          <h2 className="heading-secondary">
            Vă așteptăm cu drag să descoperiți arta florilor la Gardenia Flowers
          </h2>
          <p className="about-text">
            Uneori nu ai nevoie de un motiv ca să surprinzi pe cineva. Tratăm
            fiecare client ca pe un oaspete de onoare si garantăm calitatea,
            prospețimea florilor și o experiență de neuitat.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;
